const PROGRESS_SUMMARY_STATUS = {
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  NOT_STARTED: 'NOT_STARTED',
  OVERDUE: 'OVERDUE',
} as const;

export default PROGRESS_SUMMARY_STATUS;
